import { IntlShape } from "react-intl";
import { TranslationKey } from "./TranslationKey";

export const GetTranslation = (intl: IntlShape, key: TranslationKey) => {
  if (!key) {
    console.warn("GetTranslation: invalid 'key' parameter.");
    return "";
  }

  const containsSeveralKeys = key.indexOf("{") >= 0;
  if (!containsSeveralKeys) {
    return intl.formatMessage({ id: key });
  }

  const keysToTranslate = key.match(/({[\w-\s.äöüÄÖÜß]+})/g) || [];

  let translatedText = "";
  keysToTranslate.forEach((key) => {
    const keyWithoutBraces = key.replace("{", "").replace("}", "");
    translatedText = translatedText.replace(key, intl.formatMessage({ id: keyWithoutBraces }));
  });

  return translatedText;
};
